export default __webpack_public_path__ + "static/media/upee.96657acb.mp4";